import React from "react";
import { Column } from "@ant-design/charts";

interface FiveGBrandsColumnProps {
  data: Array<{ brand: string; count: string }>;
}

export const FiveGBrandsColumn: React.FC<FiveGBrandsColumnProps> = ({
  data,
}) => {
  if (!data || data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const chartData = data.map((r) => ({
    brand: r.brand || "Bilinmeyen",
    count: parseInt(r.count, 10),
  }));

  const config = {
    data: chartData,
    xField: "brand",
    yField: "count",
    color: "#459cd3",
    style: {
      maxWidth: 40,
    },
    label: {
      text: (d: any) => String(d.count),
      position: "inside" as const,
      style: { fill: "#fff", fontWeight: 600 },
    },
    axis: {
      x: {
        labelAutoRotate: true,
      },
    },
  };

  return <Column {...config} />;
};
